var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10525",
    "data-name": "Group 10525",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.89,
    height: 59.498,
    viewBox: "0 0 68.89 59.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4365",
    "data-name": "Rectangle 4365",
    width: 68.89,
    height: 59.498,
    fill: "#ef7b13"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10524",
    "data-name": "Group 10524",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44459",
    "data-name": "Path 44459",
    d: "M68.89,80.461a5.608,5.608,0,0,1-1.96,2.955,9.392,9.392,0,0,1-3.665,1.2C55.784,86.3,48.3,87.96,40.736,89.646q0,1.6,0,3.207c0,.538.02,1.077-.006,1.614-.058,1.221-.592,1.736-1.813,1.742-1.973.01-3.945,0-5.918,0-.986,0-1.973.005-2.959,0-1.327-.009-1.864-.537-1.881-1.879-.017-1.3,0-2.6,0-3.9v-.778c-2.081-.468-4.124-.932-6.168-1.387q-9.1-2.026-18.2-4.051a4.691,4.691,0,0,1-3.786-4.73q-.012-4.842,0-9.684a4.655,4.655,0,0,1,4.809-4.923c.112,0,.224,0,.336,0q29.287,0,58.575,0a4.76,4.76,0,0,1,4.268,1.95,12.562,12.562,0,0,1,.9,1.931Zm-28.1,5.991c.269-.051.489-.087.706-.135Q52.753,83.8,64.01,81.281c1.39-.31,1.739-.725,1.741-2.17q.005-4.507,0-9.014c0-1.568-.476-2.037-2.044-2.037H5.185c-1.568,0-2.043.469-2.045,2.038q-.007,4.507,0,9.014c0,1.448.348,1.858,1.74,2.169q9.785,2.186,19.569,4.383c1.21.271,2.423.53,3.713.812,0-.46-.028-.817.005-1.169.095-1.021.571-1.588,1.469-1.6q4.809-.041,9.619,0a1.335,1.335,0,0,1,1.4,1.269c.077.459.088.928.136,1.473m-3.272.416H31.388v6.189h6.129Z",
    transform: "translate(0 -53.943)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44460",
    "data-name": "Path 44460",
    d: "M42.027,221.7q-13.891,0-27.782.007a4.561,4.561,0,0,1-4.584-2.646,5.811,5.811,0,0,1-.486-2.334c-.037-6.57-.027-13.139-.017-19.709,0-1.477.851-2.2,2.087-1.841a1.457,1.457,0,0,1,1.06,1.529c.021,1.031.007,2.063.007,3.094q0,8.341,0,16.683c0,1.593.491,2.09,2.084,2.09q27.647,0,55.294,0c1.624,0,2.1-.49,2.1-2.14q0-9.72,0-19.441c0-1.182.413-1.739,1.377-1.89a1.473,1.473,0,0,1,1.707,1.231,5.476,5.476,0,0,1,.071.869q.006,9.653.005,19.306a4.9,4.9,0,0,1-1.86,4.252,4.322,4.322,0,0,1-2.613.923q-5.011.02-10.023.017-9.216,0-18.431,0",
    transform: "translate(-7.606 -162.21)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44461",
    "data-name": "Path 44461",
    d: "M142.51.01c2.624,0,5.248-.027,7.871.008a4.422,4.422,0,0,1,4.494,3.672,11.528,11.528,0,0,1,.067,2.943,1.388,1.388,0,0,1-1.555,1.181,1.417,1.417,0,0,1-1.473-1.283c-.07-.711-.058-1.431-.129-2.142a1.235,1.235,0,0,0-1.171-1.175,6.374,6.374,0,0,0-.866-.081q-7.266-.007-14.531,0c-.09,0-.179,0-.269,0-1.3.039-1.821.556-1.862,1.849-.016.515.008,1.033-.041,1.545a1.549,1.549,0,0,1-2.994.245c-.206-1.791-.3-3.593.989-5.111A4.274,4.274,0,0,1,134.3.033C137.038-.01,139.774.02,142.51.02V.01",
    transform: "translate(-108.034 0)",
    fill: "#ef7b13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobIcon);
export default __webpack_public_path__ + "static/media/job-icon.c1b4fde454c210dfadaf9ffc0c6cf7ef.svg";
export { ForwardRef as ReactComponent };